<template>
  <v-runtime-template :template="includeTemplate"/>
</template>

<script>
import VRuntimeTemplate from 'v-runtime-template'
import wepHtmlToString from '@/plugins/_common/WepHtmlToString'
import { isEmpty } from 'lodash'
export default {
  name: 'PtptConfmTyp',
  components: {
    VRuntimeTemplate
  },
  props: {
    step: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      includeHtml: '',
      basePath: this.getStore('mmpAuth').state.basePath,
      ptptConfmMsg: ''
    }
  },
  computed: {
    includeTemplate () {
      return this.includeHtml
    }
  },
  watch: {
  },
  async created () {
    if (isEmpty(wepHtmlToString.fifthSubTemplate)) {
      this.getEmptyTemplate('wepPtptConfm.html')
    } else {
      this.includeHtml = wepHtmlToString.fifthSubTemplate
    }
    this.getWepApcId()
  },
  methods: {
    getEmptyTemplate (resourceUrl) {
      resourceUrl = this.getTemplatePath(resourceUrl)
      this.$http.loadRes(resourceUrl).then( (res) => {
        wepHtmlToString.fifthSubTemplate = res
        this.includeHtml = wepHtmlToString.fifthSubTemplate
      })
    },
    async getWepApcId () {
      let params = {'wepApcId': this.$route.params.wepApcId}

      let resultInfo = await this.$http.mmp.memberConfirm(this, params)

      if (resultInfo.data.status !== 'OK') {
        this.ptptConfmMsg = this.$t('WEP00023')
      } else if (resultInfo.data.data.rltCode === '01') {
        this.ptptConfmMsg = this.$t('WEP00022')
      } else {
        this.ptptConfmMsg = this.$t('WEP00023')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/contents/main/PtptConfmTyp.vue